
import { useNavigate } from "react-router-dom";
import { URL_BACKEND } from "../../api/url";
import { elToast } from "../../functions/alertas";
import formatearTextoFechaIncorrecta from "../../functions/formatearTextoFechaIncorrecta";

import Cookies from 'universal-cookie';

export const useFormularioLogin = () => {

    const navigate = useNavigate();
    const cookies = new Cookies();

    const onFinish = ( values ) => {

        values.funcion = 'loginAspirante'

        fetch( URL_BACKEND, {
            method: "post",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify( values )
        })
        .then( res => res.json())
        .then( function(d) {
            // resultado del login

            if ( d.codigo == 1 ) {

                let pk_aspirante = d.datos[0].pk_aspirante;
                let fk_carrera = d.datos[0].fk_carrera;
                let nivel = d.datos[0].nivel;
                cookies.set("pk_aspirante", pk_aspirante, { path: "/" });
                cookies.set("fk_carrera", fk_carrera, { path: "/" });
                cookies.set("nivel", nivel, { path: "/" });

                elToast( d.mensaje )
                navigate( 'examen' )


            } else if (d.codigo == 0) {

                elToast( d.mensaje, 'error' )

            }else if (d.codigo == 2) {

                let texto = formatearTextoFechaIncorrecta(d.datos);

                elToast( texto, "info" );

            }


        })
        .catch( () => {
            elToast('Ocurrió un problema al iniciar sesión, vuelve a intentarlo.', "error");
        })

    };

    return {
        onFinish
    }
}
